import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";
import './modal_info_sanierungsfahrplan.css';

import { useStore } from "../state/state.ts";
import { PanelImg } from '../components/img.tsx';
import { ModalClose } from '../components/modal-close.tsx';

export default function ModalInfoSanierungsfahrplan() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1 id="modal-title">Was bedeutet individueller Sanierungsfahrplan?</h1>
            <p id="modal-description">Im individuellen Sanierungsfahrplan (iSFP) vorgeschlagene Maßnahmen erhalten die erhöhte BEG-Förderung von 20 %. Die für die Förderung ansetzbaren Kosten erhöhen sich von 30.000 € auf 60.000 € je Wohneinheit und Kalenderjahr.</p>            
            <figure>
                <legend>BEG-Einzelmaßnahme Beispielrechnung Einfamilienhaus</legend>
                <table className="isptable" cellSpacing="0" cellpadding="0" border="0"> 
                <tr>
                    <th>förderfähige Investitionskosten je Wohneinheit</th>
                    <th>ohne iSFP 15% Zuschuss</th>
                    <th>mit iSFP 20% Zuschuss</th>
                    <th>Förderplus mit iSFP</th>
                </tr>
                <tr>
                    <td>10.000 €</td>
                    <td>1.500 €</td>
                    <td>2.000 €</td>		
                    <td>500 €</td>
                </tr>
                <tr>
                    <td>25.000 €</td>
                    <td>3.750 €</td>
                    <td>5.000 €</td>		
                    <td>1.250 €</td>
                </tr>
                <tr>
                    <td>30.000 €</td>
                    <td>4.500 €</td>
                    <td>6.000 €</td>		
                    <td>1.500 €</td>
                </tr>
                <tr>
                    <td>45.000 €</td>
                    <td>4.500 €</td>
                    <td>9.000 €</td>		
                    <td>4.500 €</td>
                </tr>
                <tr>
                    <td>50.000 €</td>
                    <td>4.500 €</td>
                    <td>10.000 €</td>		
                    <td>5.500 €</td>
                </tr>
                <tr>
                    <td>55.000 €</td>
                    <td>4.500 €</td>
                    <td>11.000 €</td>		
                    <td>6.500 €</td>
                </tr>
                <tr>
                    <td>max. 60.000 €</td>
                    <td>4.500 €</td>
                    <td>12.000 €</td>		
                    <td>7.500 €</td>
                </tr>
                </table>
            </figure>
           
             <ModalClose label={"weiter"} onClick={()=>{
                            pop_modal();
                        }}/>
         </Panel>)
}

